// Module
var code = "<md-button class=\"btnDefault\" ng-click=\"onClick()\">{{label}}</md-button>\n";
// Exports
module.exports = code;